import Vue from "vue"
import VDateField from 'Components/common/VDateField'
import DatetimePicker from 'vuetify-datetime-picker'

Vue.component('v-date-field', VDateField)

Vue.use(DatetimePicker);
